// ─── Seção do Banner ─────────────────────────────────────────────────────────
function initBanner() {
  document.querySelectorAll(".home-banner").forEach((section) => {
    const slides = Array.from(section.querySelectorAll(".home-banner__slide"));
    const prev = section.querySelector(".home-banner__nav-btn--prev");
    const next = section.querySelector(".home-banner__nav-btn--next");
    const dotsWrap = section.querySelector(".home-banner__dots");
    const dots = Array.from(section.querySelectorAll(".home-banner__dot"));

    if (slides.length < 2) {
      return;
    }

    const getActiveIndex = () => {
      const index = slides.findIndex((s) => s.classList.contains("is-active"));
      return index === -1 ? 0 : index;
    };

    const setActive = (index) => {
      slides.forEach((s, i) => s.classList.toggle("is-active", i === index));
      dots.forEach((d, i) => d.classList.toggle("is-active", i === index));
      prev?.classList.toggle("is-hidden", index === 0);
      next?.classList.toggle("is-hidden", index === slides.length - 1);

      const textColor = slides[index]?.style.getPropertyValue(
        "--banner-text-color",
      );

      if (textColor) {
        dotsWrap?.style.setProperty("--banner-text-color", textColor);
      }
    };

    prev?.addEventListener("click", () => {
      const index = getActiveIndex();

      if (index > 0) {
        setActive(index - 1);
      }
    });

    next?.addEventListener("click", () => {
      const index = getActiveIndex();

      if (index < slides.length - 1) {
        setActive(index + 1);
      }
    });

    dots.forEach((dot, i) => {
      dot.addEventListener("click", () => setActive(i));
    });

    setActive(getActiveIndex());
  });
}

// ─── Seção dos Programas Abertos ─────────────────────────────────────────────
function initProgramasAbertos() {
  document.querySelectorAll(".home-programas__cards").forEach((container) => {
    const cards = Array.from(
      container.querySelectorAll(".home-programas__card"),
    );
    const section = container.closest(".home-programas");
    const prev = section?.querySelector(".home-programas__nav-btn--prev");
    const next = section?.querySelector(".home-programas__nav-btn--next");

    if (!cards.length || !prev || !next) {
      return;
    }

    let activeIndex = 0;

    const isMobile = () => window.innerWidth <= 1024;

    const renderDesktop = () => {
      const step = cards[0].offsetWidth + 24;

      cards.forEach((card, i) => {
        const slot = i - activeIndex;

        if (slot === -1) {
          // Card que acabou de sair: encolhe e vai para trás do novo card ativo
          card.style.transform = "translateX(0) scale(0.85)";
          card.style.opacity = "0";
          card.style.zIndex = "1";
          card.style.pointerEvents = "none";
        } else if (slot >= 0 && slot <= 2) {
          card.style.transform = `translateX(${slot * step}px) scale(1)`;
          card.style.opacity = "1";
          card.style.zIndex = String(5 - slot);
          card.style.pointerEvents = "auto";
        } else if (slot > 2) {
          card.style.transform = `translateX(${3 * step}px) scale(1)`;
          card.style.opacity = "0";
          card.style.zIndex = "0";
          card.style.pointerEvents = "none";
        } else {
          card.style.transform = "translateX(0) scale(0.85)";
          card.style.opacity = "0";
          card.style.zIndex = "0";
          card.style.pointerEvents = "none";
        }
      });
    };

    const renderMobile = () => {
      const cardWidth = cards[0].offsetWidth;
      const gap = 10;
      const base = (container.offsetWidth - cardWidth) / 2;
      const step = cardWidth + gap;

      cards.forEach((card, i) => {
        const slot = i - activeIndex;
        card.style.transform = `translateX(${base + slot * step}px) scale(1)`;

        if (slot === 0) {
          card.style.opacity = "1";
          card.style.pointerEvents = "auto";
        } else if (slot === -1 || slot === 1) {
          card.style.opacity = "0.5";
          card.style.pointerEvents = "none";
        } else {
          card.style.opacity = "0";
          card.style.pointerEvents = "none";
        }

        card.style.zIndex = slot === 0 ? "2" : "1";
      });
    };

    const render = () => {
      if (isMobile()) {
        renderMobile();
      } else {
        renderDesktop();
      }

      prev.disabled = activeIndex === 0;
      next.disabled = activeIndex === cards.length - 1;
    };

    prev.addEventListener("click", () => {
      if (activeIndex > 0) {
        activeIndex--;
        render();
      }
    });

    next.addEventListener("click", () => {
      if (activeIndex < cards.length - 1) {
        activeIndex++;
        render();
      }
    });

    window.addEventListener("resize", render);
    render();
  });
}

// ─── FAQ Accordion ───────────────────────────────────────────────────────────
function initFaq() {
  const items = document.querySelectorAll("[data-faq-item]");

  if (!items.length) {
    return;
  }

  items.forEach((item) => {
    const btn = item.querySelector(".home-faq__question");

    if (!btn) {
      return;
    }

    btn.addEventListener("click", () => {
      const isOpen = item.classList.contains("is-open");

      items.forEach((item) => {
        item.classList.remove("is-open");
        item
          .querySelector(".home-faq__question")
          ?.setAttribute("aria-expanded", "false");
      });

      if (!isOpen) {
        item.classList.add("is-open");
        btn.setAttribute("aria-expanded", "true");
      }
    });
  });
}

// ─── Profissionais – vídeo por card ────────────────────────────────────────────────
function initProfissionaisVideos() {
  document
    .querySelectorAll(".home-profissionais__card[data-yt-url]")
    .forEach((card) => {
      const btn = card.querySelector(".home-profissionais__card-play");

      if (!btn) {
        return;
      }

      btn.addEventListener(
        "click",
        () => {
          const url = card.dataset.ytUrl || "";
          const urlMatch = url.match(
            /(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([^&?#]+)/,
          );

          if (!urlMatch?.[1]) {
            return;
          }

          const iframe = document.createElement("iframe");
          iframe.src = `https://www.youtube.com/embed/${urlMatch[1]}?autoplay=1`;
          iframe.setAttribute(
            "allow",
            "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
          );
          iframe.setAttribute("allowfullscreen", "");
          iframe.className = "home-profissionais__card-iframe";
          card.replaceChildren(iframe);
          card.style.cursor = "default";
        },
        { once: true },
      );
    });
}

// ─── Metodologia Explicada ────────────────────────────────────────────────────
function initMetodologia() {
  document.querySelectorAll(".home-metodologia__slider").forEach((slider) => {
    const grid = slider.querySelector(".home-metodologia__cards");
    const prev = slider.querySelector(".home-metodologia__nav-btn--prev");
    const next = slider.querySelector(".home-metodologia__nav-btn--next");
    const cards = grid
      ? Array.from(grid.querySelectorAll(".home-metodologia__card"))
      : [];

    cards.forEach((card) => {
      card.addEventListener("click", () => {
        if (window.innerWidth <= 1024) {
          return;
        }

        if (card.classList.contains("is-active")) {
          return;
        }

        cards.forEach((c) => c.classList.remove("is-active"));
        card.classList.add("is-active");
      });
    });

    if (!grid || !prev || !next || !cards.length) {
      return;
    }

    const getActiveIndex = () => {
      const index = cards.findIndex((c) => c.classList.contains("is-active"));
      return index === -1 ? 0 : index;
    };

    const setActive = (index) => {
      cards.forEach((c, i) => c.classList.toggle("is-active", i === index));
      prev.disabled = index <= 0;
      next.disabled = index >= cards.length - 1;
    };

    setActive(getActiveIndex());

    prev.addEventListener("click", () => {
      const index = getActiveIndex();

      if (index > 0) {
        setActive(index - 1);
      }
    });
    next.addEventListener("click", () => {
      const index = getActiveIndex();

      if (index < cards.length - 1) {
        setActive(index + 1);
      }
    });
  });
}

// ─── Ecossistema – carousel mobile ───────────────────────────────────────────
function initEcossistema() {
  const grid = document.querySelector(".home-ecossistema__cards");

  if (!grid) {
    return;
  }

  const cards = Array.from(grid.querySelectorAll(".home-ecossistema__card"));
  const prev = document.querySelector(".home-ecossistema__nav-btn--prev");
  const next = document.querySelector(".home-ecossistema__nav-btn--next");

  if (!cards.length || !prev || !next) {
    return;
  }

  const cardWidth = () => cards[0].offsetWidth + 10;

  const update = () => {
    const index = Math.round(grid.scrollLeft / cardWidth());
    cards.forEach((card, i) => card.classList.toggle("is-active", i === index));
    prev.disabled = index <= 0;
    next.disabled = index >= cards.length - 1;
  };

  update();
  grid.addEventListener("scroll", update, { passive: true });
  prev.addEventListener("click", () =>
    grid.scrollBy({ left: -cardWidth(), behavior: "smooth" }),
  );
  next.addEventListener("click", () =>
    grid.scrollBy({ left: cardWidth(), behavior: "smooth" }),
  );
}

// ─── Sócios e Executivos ────────────────────────────────────────────────────
function initSocios() {
  document.querySelectorAll(".home-socios__slider").forEach((slider) => {
    const grid = slider.querySelector(".home-socios__cards");
    const prev = slider.querySelector(".home-socios__nav-btn--prev");
    const next = slider.querySelector(".home-socios__nav-btn--next");
    const cards = grid
      ? Array.from(grid.querySelectorAll(".home-socios__card"))
      : [];

    const isMobile = () => window.innerWidth <= 1024;

    cards.forEach((card) => {
      card.addEventListener("click", () => {
        if (!isMobile()) {
          return;
        }

        card.classList.toggle("is-flipped");
      });

      card
        .querySelector(".home-socios__card-back")
        ?.addEventListener("click", (event) => {
          event.stopPropagation();
          card.classList.remove("is-flipped");
        });
    });

    if (!grid || !prev || !next || cards.length < 2) {
      prev?.remove();
      next?.remove();
      return;
    }

    // Mobile: um card por vez, alternado pela classe is-active
    const getActiveIndex = () => {
      const index = cards.findIndex((c) => c.classList.contains("is-active"));
      return index === -1 ? 0 : index;
    };

    const setActiveMobile = (index) => {
      cards.forEach((c, i) => c.classList.toggle("is-active", i === index));
      cards.forEach((c) => c.classList.remove("is-flipped"));
      prev.disabled = index <= 0;
      next.disabled = index >= cards.length - 1;
    };

    // Desktop: scroll horizontal (mostra 4, revela o resto ao clicar)
    const cardWidth = () =>
      cards[0] ? cards[0].offsetWidth + 12 : grid.offsetWidth;

    const updateDesktop = () => {
      const max = grid.scrollWidth - grid.clientWidth - 1;
      prev.disabled = grid.scrollLeft <= 0;
      next.disabled = grid.scrollLeft >= max;
    };

    const update = () => {
      if (isMobile()) {
        setActiveMobile(getActiveIndex());
      } else {
        updateDesktop();
      }
    };

    update();
    window.addEventListener("resize", update);
    grid.addEventListener(
      "scroll",
      () => {
        if (!isMobile()) {
          updateDesktop();
        }
      },
      { passive: true },
    );

    prev.addEventListener("click", () => {
      if (isMobile()) {
        const index = getActiveIndex();

        if (index > 0) {
          setActiveMobile(index - 1);
        }
      } else {
        grid.scrollBy({ left: -cardWidth(), behavior: "smooth" });
      }
    });

    next.addEventListener("click", () => {
      if (isMobile()) {
        const index = getActiveIndex();

        if (index < cards.length - 1) {
          setActiveMobile(index + 1);
        }
      } else {
        grid.scrollBy({ left: cardWidth(), behavior: "smooth" });
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initBanner();
  initProgramasAbertos();
  initFaq();
  initProfissionaisVideos();
  initMetodologia();
  initEcossistema();
  initSocios();
});
